export default __webpack_public_path__ + "static/media/Erinavatar.27299724.png";